import Vue from 'vue';
import Router from 'vue-router';
import Landing from '../components/Landing.vue';
import Login from '../components/cms/Login.vue';
import Catagories from '../components/cms/Catagories.vue';
import Jewelry from '../components/cms/Jewelry.vue';
import CmsContainer from '../components/cms/CmsContainer.vue';
import CollectionContainer from '../components/collections/CollectionContainer.vue';
import ChooseCollection from '../components/collections/ChooseCollection.vue';
import ViewCollection from '../components/collections/ViewCollection.vue';
import { store } from '../store';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    { path: '/', name: 'landing', component: Landing },
    { path: '/login', name: 'cms-login', component: Login },
    { path: '/cms', name: 'cms-wrapper', component: CmsContainer,
      children: [
        {
          name: 'catagory',
          path: 'catagories',
          component: Catagories
        },
        {
          name: 'jewelry',
          path: 'jewelry',
          component: Jewelry
        },
       
      ]
    },
    { path: '/collections', name: 'collection-wrapper', component: CollectionContainer,
      children: [
        {
          name: 'choose-collection',
          path: 'choose-collection',
          component: ChooseCollection
        },
        {
          name: 'view-collection',
          path: 'view-collection',
          component: ViewCollection
        }
      ]
    },
    {
      path: '*',
      component: Error
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js